The type of the component.

Currently, two codes are defined:

- `PrivacyConsent` which corresponds to the `ApplicationPrivacyConsent` type.
- `Question` which corresponds to the `ApplicationQuestion` type.
